import React from "react";
import LoginPhone from '../modules/Authentication/Login/LoginPhone';
import LoginOTP from '../modules/Authentication/Login/LoginOTP';
import RegisterPhone from '../modules/Authentication/Register/RegisterPhone';
import RegisterOTP from '../modules/Authentication/Register/RegisterOTP';
import CreateNewAccount from '../modules/Authentication/Register/CreateNewAccount';
import ExploreCourses from "../modules/Course/ExploreCourses";
import CourseDetail from "../modules/Course/CourseDetail";
import ShoppingCart from "../modules/Course/ShoppingCart";

// Public web-facing course pages (no auth/token required)
import ExploreCoursesWeb from "../modules/CourseWeb/ExploreCourses";
import ExploreCoursesAndInsurance from "../modules/CourseWeb/ExploreCoursesAndInsurance";
import CourseDetailWeb from "../modules/CourseWeb/CourseDetail";
import ShoppingCartWeb from "../modules/CourseWeb/ShoppingCart";
import OrderHistory from "../modules/Orderhistory/orderhistory";
import BuyNowWeb from "modules/CourseWeb/BuyNow";

// Insurance pages (no auth required)
import InsurancePage from "../modules/Insurance/insurance";
import InsuranceDetail from "../modules/Insurance/insurancedetail";

// Legal pages (no auth required)
import TermsAndConditions from "../modules/Legal/TermsAndConditions";
import PrivacyPolicy from "../modules/Legal/PrivacyPolicy";
import RefundPolicy from "../modules/Legal/RefundPolicy";

type AppRoute = {
  path: string;
  component: JSX.Element;
  constant: string;
};

const authProtectedRoutes: AppRoute[] = [
  { path: '*', component: <ExploreCourses />, constant: 'course' }
]

const publicRoutes = [
  { path: "/login", component: <LoginPhone /> },
  { path: "/login-otp", component: <LoginOTP /> },
  { path: "/register", component: <RegisterPhone /> },
  { path: "/register-otp", component: <RegisterOTP /> },
  { path: "/create-account", component: <CreateNewAccount /> },
  { path: "/terms-and-conditions", component: <TermsAndConditions /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/refund-policy", component: <RefundPolicy /> },

  // New public, unauthenticated web course routes - merged with insurance
  { path: "/services", component: <ExploreCoursesAndInsurance /> },
  { path: "/services/:id", component: <CourseDetailWeb /> },
  { path: "/services/cart", component: <ShoppingCartWeb /> },
  { path: "/services/buynow", component: <BuyNowWeb /> },
  { path: "/order-history", component: <OrderHistory /> },

  { path: "/insurance", component: <ExploreCoursesAndInsurance /> },
  { path: "/insurance/:id", component: <InsuranceDetail /> },

  { path: "/course", component: <ExploreCourses /> },
  { path: "/explore-courses", component: <ExploreCoursesAndInsurance /> },
  { path: "/course/:id", component: <CourseDetail /> },
  { path: "/cart", component: <ShoppingCart /> },
];

export { authProtectedRoutes, publicRoutes };
